export {};
import { collection, doc, getDocs, writeBatch } from 'firebase/firestore';

type FeatureDetail = {
    permissions: string[];
};

type FeatureObject = {
    featureDetails: {
        [key: string]: FeatureDetail;
    };
    features: string[];
    key: string | null;
};

export class User {
    db: any;
    uid: string;
    orgId: string;
    userDoc: any;
    userOrgSubCDoc: any;
    userOrgs: any[] = [];
    userSecurityGroups: any[] = [];
    userSecurityGroupsKeys: any[] = [];
    userSecurityGroupDetails: any[] = [];
    userHats: any[] = [];
    userHatsDetails: any[] = [];
    userHatsKeys: any[] = [];
    userFeatures: any[] = [];
    userFeatureDetails: any = {};

    orgUsersSubCDocs: any[] = [];
    orgSecurityGroupsDocs: any[] = [];
    orgPartsSubCDocs: any[] = [];
    orgHats: any[] = [];
    firebaseUsers: any[] = [];
    firebaseUser: any = {};
    userPositions: any[] = [];
    userPositionKeys: Set<string> = new Set<string>();

    constructor(db: any, userId: string, orgId: string) {
        this.uid = userId;
        this.orgId = orgId;
        this.db = db;
        this.initialize();
    }

    async initialize() {
        const orgRef = doc(this.db, 'organizations', this.orgId); // db.collection('organizations').doc(orgId);

        const jobs: Promise<any>[] = [];
        const options: any = {};

        options.orgRef = orgRef;
        options.orgId = this.orgId;

        // const batch = writeBatch(this.db);

        options.orgRef = orgRef;
        options.orgId = this.orgId;

        let job: any = {};
        job = this.getAllFirebaseUsers(options, this.db)
            .then()
            .catch((err) => {
                console.error('error status: ', err);
                // rejects(err);
            });
        jobs.push(job);
        // }ß

        job = this.getAllOrgSecurityGroupsSubCollectionsDoc(options, this.db)
            .then()
            .catch((err) => {
                console.error('error status: ', err);
                // rejects(err);
            });
        jobs.push(job);

        job = this.getAllOrgHatsSubCollection(options, this.db)
            .then()
            .catch((err) => {
                console.error('error status: ', err);
                // rejects(err);
            });
        jobs.push(job);

        job = this.getAllOrgUserSubCollection(options, this.db)
            .then()
            .catch((err) => {
                console.error('error status: ', err);
                // rejects(err);
            });
        jobs.push(job);
        job = this.getAllOrgPartsSubCollection(options, this.db)
            .then()
            .catch((err) => {
                console.error('error status: ', err);
                // rejects(err);
            });
        jobs.push(job);

        // let firebaseUsers: any = [];
        // let orgSecurityGroupsDocs: any = [];
        // let orgHats: any = [];
        // let orgUsersSubCDocs: any = [];

        // Execute all jobs concurrently
        const allDbResults = await Promise.allSettled(jobs);

        allDbResults.forEach((result) => {
            if (result.status === 'fulfilled') {
                if (result.value.collection === 'users') {
                    this.firebaseUsers = result.value.firebaseUsers;
                } else if (result.value.collection === 'organizations/hats') {
                    this.orgHats = result.value.orgHatsSubCDocs;
                } else if (result.value.collection === 'organizations/users') {
                    this.orgUsersSubCDocs = result.value.orgUsersSubCDocs;
                } else if (result.value.collection === 'organizations/securityGroups') {
                    this.orgSecurityGroupsDocs = result.value.orgSecurityGroupsSubCDocs;
                } else if (result.value.collection === 'organizations/parts') {
                    this.orgPartsSubCDocs = result.value.allOrgPartsSubCDocs;
                }
            }
        });

        this.userDoc = this.setUserFrom();
        this.userHats = this.setUserHatsFrom();
        this.userSecurityGroups = this.setUserSecurityGroups();
        this.userPositions = this.setUserPositions().userPositions;
        this.userPositionKeys = this.setUserPositions().userPositionKeys;
        this.userSecurityGroupDetails = this.setSecurityGroupDetails();
        this.userFeatures = this.setUserFeatureDetailsKeys();
        this.userHatsDetails = this.setUserHatsDetails();
        this.userHatsKeys = this.setUserHatsKeys();
        this.userFeatureDetails = this.mergeFeatureDetails();
        this.userSecurityGroupsKeys = this.setUserSecurityGroupsKeys();
        this.firebaseUser = this.getFirebaseUserFrom();

        return this;
    }

    getUserSecurityGroupsKeys() {
        return this.userSecurityGroupsKeys;
    }

    getUserSecurityGroupDetails() {
        return this.userSecurityGroupDetails;
    }

    getUserFeatureDetails() {
        return this.userFeatureDetails;
    }

    getUserHats() {
        return this.userHats;
    }

    createOrgUserSubCollectionUpdateObject() {
        const userHatsKeys = this.setUserHatsKeys();
        const userHatsDetails = this.setUserHatsDetails();
        return {
            securityGroups: this.userSecurityGroupsKeys,
            securityGroupsDetails: this.userSecurityGroupDetails,
            featureDetails: this.userFeatureDetails,
            features: Object.keys(this.userFeatureDetails),
            hats: userHatsKeys,
            hatsDetails: userHatsDetails,
            email: this.firebaseUser?.email || null,
            name: this.firebaseUser?.displayName || this.userDoc?.name || null,
            userName: this.firebaseUser?.displayName || this.userDoc?.userName || null,
        };
    }

    updateOrgSecurityObject() {
        const orgSecurityObject = this.firebaseUser?.organizations || {};
        const orgSecurityObjectOrg = orgSecurityObject[this.orgId];

        orgSecurityObjectOrg.dashboards = this.userDoc.dashboards;
        orgSecurityObjectOrg.features = Object.keys(this.userFeatureDetails);
        orgSecurityObjectOrg.featureDetails = this.userFeatureDetails;
        orgSecurityObjectOrg.hats = this.userHatsKeys;
        orgSecurityObjectOrg.securityGroups = this.userSecurityGroupsKeys;

        orgSecurityObject[this.orgId] = orgSecurityObjectOrg;
        return orgSecurityObject;
    }

    setUserFrom() {
        const userDoc = this.orgUsersSubCDocs.find((doc: any) => doc.key === this.uid);
        if (userDoc) {
            // Add any additional processing logic here

            return userDoc;
        } else {
            // todo
        }
    }

    getFirebaseUserFrom() {
        const firebaseUser = this.firebaseUsers.find((user: any) => user.uid === this.uid);
        if (firebaseUser) {
            return firebaseUser;
        } else {
            return null;
        }
    }

    setUserHatsFrom() {
        const userHats = this.orgHats.filter((hat: any) => hat.assignedToArray.includes(this.uid));
        return userHats;
    }

    setUserHatsKeys() {
        const userHatsKeys: any = [];
        this.userHats.map((doc: any) => {
            userHatsKeys.push(doc.key);
        });
        return userHatsKeys;
    }

    setUserSecurityGroups() {
        const userSecurityGroupsKeys = new Set<string>();

        // Collect all security group keys from user hats
        this.userHats.forEach((hat: any) => {
            hat.securityGroupsArray.forEach((securityGroupKey: string) => {
                userSecurityGroupsKeys.add(securityGroupKey);
            });
        });

        // Find the security groups from orgSecurityGroupsDocs
        const userSecurityGroups = this.orgSecurityGroupsDocs.filter((securityGroup: any) =>
            userSecurityGroupsKeys.has(securityGroup.key)
        );

        return userSecurityGroups;
    }

    setUserPositions() {
        // const userPositionsKeys = new Set<string>();

        // Collect all parts keys from user hats
        this.userHats.forEach((hat: any) => {
            hat?.positionArray?.forEach((positionKey: string) => {
                this.userPositionKeys.add(positionKey);
            });
        });

        // // Find the security groups from orgSecurityGroupsDocs
        // const userSecurityGroups = this.orgPartsSubCDocs.filter((part: any) =>
        //     userPositionsKeys.has(part.key)
        // );

        // const userPositionKeys = new Set<string>();
        // userSecurityGroups.forEach((group: any) => {
        //     group.positions.forEach((position: any) => {
        //         userPositionKeys.add(position.key);
        //     });
        // });

        // Find the positions from orgParts
        const userPositions = this.orgPartsSubCDocs.filter((position: any) =>
            this.userPositionKeys.has(position.partKey)
        );

        return { userPositions, userPositionKeys: this.userPositionKeys };
    }

    setSecurityGroupDetails() {
        const securityGroupDetails: any = {};

        this.userSecurityGroups.forEach((group: any) => {
            const securityGroupDetail = this.orgSecurityGroupsDocs.find((doc: any) => doc.key === group.key);
            if (securityGroupDetail) {
                securityGroupDetails[group.key] = securityGroupDetail;
            }
        });

        return securityGroupDetails;
    }

    setUserFeatureDetailsKeys(): string[] {
        return Object.keys(this.userFeatureDetails);
    }

    setUserHatsDetails() {
        const userHatsDetails: any = {};
        this.userHats.forEach((item: any) => {
            // if (securityGroupKey !== securityGroupId) {
            userHatsDetails[item.key] = item;
            // }
        });
        return userHatsDetails;
    }

    mergeFeatureDetails() {
        const mergedFeatureDetails: { [key: string]: { permissions: string[] } } = {};
        const data = this.userSecurityGroups as FeatureObject[];
        data.forEach((item) => {
            Object.keys(item.featureDetails).forEach((key) => {
                if (!mergedFeatureDetails[key]) {
                    // Only include permissions
                    mergedFeatureDetails[key] = {
                        permissions: item.featureDetails[key].permissions,
                    };
                } else {
                    // Merge permissions without duplicates
                    const existingPermissions = mergedFeatureDetails[key].permissions;
                    const newPermissions = item.featureDetails[key].permissions;
                    mergedFeatureDetails[key].permissions = Array.from(
                        new Set([...existingPermissions, ...newPermissions])
                    );
                }
            });
        });

        return mergedFeatureDetails;
    }

    setUserSecurityGroupsKeys() {
        let userSecurityGroupsKeys: any = [];
        this.userHats.forEach((hat: any) => {
            userSecurityGroupsKeys.push(...hat.securityGroupsArray);
        });

        userSecurityGroupsKeys = removeDuplicates(userSecurityGroupsKeys);
        return userSecurityGroupsKeys;
    }

    getAllFirebaseUsers(options: any, db: any): Promise<unknown> {
        const uid = options.uid;

        return new Promise((resolve, rejects) => {
            const usersRef = collection(db, 'users');
            getDocs(usersRef)
                // db.collection('users').doc(uid).get()
                .then((docs) => {
                    const allFirebaseUsers: any[] = [];

                    docs.forEach((doc: any) => {
                        allFirebaseUsers.push(doc.data());
                    });

                    const firebaseUserObject = {
                        firebaseUsers: allFirebaseUsers,
                        collection: 'users',
                    };
                    resolve(firebaseUserObject);
                })
                .catch((err) => {
                    console.error('getFirebaseUserDoc: uid: ', uid);
                    console.error('getFirebaseUserDoc: error fetching firebase user doc: ', err);
                    rejects(err);
                });

            // resolve(firebaseUserDoc);
            // return firebaseUserObject;
        });
    }

    getAllOrgSecurityGroupsSubCollectionsDoc(options: any, db: any): Promise<unknown> {
        const orgId = options.orgId;

        return new Promise((resolve, rejects) => {
            const securityGroupsRef = collection(db, 'organizations', orgId, 'securityGroups');
            getDocs(securityGroupsRef)
                .then((docs: any) => {
                    const allOrgSecurityGroupsDocs: any[] = [];
                    docs.forEach((doc: any) => {
                        allOrgSecurityGroupsDocs.push(doc.data());
                    });
                    const organizationSecurityGroupsObject = {
                        orgSecurityGroupsSubCDocs: allOrgSecurityGroupsDocs,
                        orgId: orgId,
                        collection: 'organizations/securityGroups',
                    };
                    resolve(organizationSecurityGroupsObject);
                })
                .catch((err) => {
                    console.error('##### error fetching org securityGroups sub-collection doc ##### ', err);
                    rejects(err);
                });
            // resolve(firebaseUserDoc);
            // return firebaseUserDoc;
        });
    }

    getAllOrgHatsSubCollection(options: any, db: any): Promise<unknown> {
        const orgId = options.orgId;
        // const uid = options.uid;

        return new Promise((resolve, rejects) => {
            // const q = query(collection(db, "organizations", orgId, 'hats'),
            // where("assignedToArray", "array-contains", uid)); // , where("status", "==", ""));
            const organizationsHatsSUbCRef = collection(db, 'organizations', orgId, 'hats');
            getDocs(organizationsHatsSUbCRef)
                .then((docs: any) => {
                    const allOrgHats: any[] = [];
                    docs.forEach((doc: any) => {
                        allOrgHats.push(doc.data());
                    });

                    const organizationSecurityGroupsForFeatureObject = {
                        orgHatsSubCDocs: allOrgHats,
                        collection: 'organizations/hats',
                    };
                    resolve(organizationSecurityGroupsForFeatureObject);
                })
                .catch((err) => {
                    console.error('##### error fetching org securityGroups sub-collection doc ##### ', err);
                    rejects(err);
                });
        });
    }

    getAllOrgUserSubCollection(options: any, db: any): Promise<unknown> {
        const orgId = options.orgId;

        return new Promise((resolve, rejects) => {
            const orgUsersSubColRef = collection(db, 'organizations', orgId, 'users');
            getDocs(orgUsersSubColRef)
                .then((docs: any) => {
                    const allOrgUsersSubCDocs: any[] = [];
                    docs.forEach((doc: any) => {
                        allOrgUsersSubCDocs.push(doc.data());
                    });
                    const organizationUsersObject = {
                        orgUsersSubCDocs: allOrgUsersSubCDocs,
                        orgId: orgId,
                        collection: 'organizations/users',
                    };
                    resolve(organizationUsersObject);
                })
                .catch((err) => {
                    console.error('##### error fetching org securityGroups sub-collection doc ##### ', err);
                    rejects(err);
                });
        });
    }

    getAllOrgPartsSubCollection(options: any, db: any): Promise<unknown> {
        const orgId = options.orgId;

        return new Promise((resolve, rejects) => {
            const orgUsersSubColRef = collection(db, 'organizations', orgId, 'parts');
            getDocs(orgUsersSubColRef)
                .then((docs: any) => {
                    const allOrgPartsSubCDocs: any[] = [];
                    docs.forEach((doc: any) => {
                        allOrgPartsSubCDocs.push(doc.data());
                    });
                    const organizationUsersObject = {
                        allOrgPartsSubCDocs: allOrgPartsSubCDocs,
                        orgId: orgId,
                        collection: 'organizations/parts',
                    };
                    resolve(organizationUsersObject);
                })
                .catch((err) => {
                    console.error('##### error fetching org parts sub-collection doc ##### ', err);
                    rejects(err);
                });
        });
    }
}

const removeDuplicates = (array: any) => {
    const a = array.concat();
    for (let i = 0; i < a.length; ++i) {
        for (let j = i + 1; j < a.length; ++j) {
            if (a[i] === a[j]) {
                a.splice(j--, 1);
            }
        }
    }

    return a;
};
